import { render, staticRenderFns } from "./export-ppt-resources.vue?vue&type=template&id=0d9e46b5&scoped=true"
import script from "./export-ppt-resources.vue?vue&type=script&lang=js"
export * from "./export-ppt-resources.vue?vue&type=script&lang=js"
import style0 from "./export-ppt-resources.vue?vue&type=style&index=0&id=0d9e46b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e46b5",
  null
  
)

export default component.exports